// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c6bff150","455":"07583b5d","977":"5032094f"}[chunkId] + ".chunk.js";
};